<template>
  <div class="page-wrapper">
    <v-col cols="12" lg="10" md="7">
      <v-form>
        <v-card class="card-shadow bg-secondary">
          <CadastroReserva />
        </v-card>
      </v-form>
    </v-col>
  </div>
</template>



<script>
import CadastroReserva from "./../Components/Cadastros/CadastroReserva.vue";
export default {
  name: "RegisterReserve",
  components: {
    CadastroReserva,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.page-wrapper {
  display: flex;
  justify-content: center;
}
</style>
